import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "withdraw-item" }
const _hoisted_2 = {
  key: 1,
  class: "item-icon"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "item-price" }
const _hoisted_5 = {
  key: 2,
  width: "6",
  height: "6",
  viewBox: "0 0 6 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "item-corner"
}
const _hoisted_6 = { class: "withdraw-user" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "user-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemIcon = _resolveComponent("ItemIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["live-withdraw", { active: _ctx.active }]),
    style: _normalizeStyle({
			'--active': _ctx.color,
			'--background': _ctx.background,
			'--border': _ctx.border
		})
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.method)
        ? (_openBlock(), _createBlock(_component_ItemIcon, {
            key: 0,
            icon: _ctx.icon,
            size: 116,
            class: "item-icon"
          }, null, 8, ["icon"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.icon,
              class: "item-method-icon",
              alt: ""
            }, null, 8, _hoisted_3)
          ])),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.amountNormalized), 1),
      (_ctx.active)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("path", {
              d: "M4 6C1.79086 6 -6.7098e-08 4.20914 -1.49868e-07 2L-2.24801e-07 4.76837e-07L3 3L6 6L4 6Z",
              fill: "currentColor"
            }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("img", {
        src: _ctx.avatar,
        class: "user-avatar",
        alt: _ctx.name
      }, null, 8, _hoisted_7),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.name), 1)
    ])
  ], 6))
}